import { Alert, Box, Collapse, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import Capa from '../../Controls/Capa/Capa';
import { AuthContext } from '../../../Context/AuthContext';
import { getLeyendaPosicionList, addLeyenda, FrmUpdateLeyendaSoc } from '../../../Service/leyenda';
import { getFormulariosList } from '../../../Service/formulariosService';

function LeyendaView(props) {

    const { accessToken } = useContext(AuthContext);
    const [posiciones, setPosiciones] = useState([]);
    const [formulariosLst, setFormulariosLst] = useState([]);

    //const [loading, setLoading] = useState(false);
    const [valCodLeyendaPosicion, setValCodLeyendaPosicion] = useState('');
    const [valCodFormulario, setValCodFormulario] = useState('');
    const [valDescLey, setValDescLey] = useState('');
    const [valValorUno, setValValorUno] = useState('');
    const [valValorDos, setValValorDos] = useState('');
    const [valValorTres, setValValorTres] = useState('');


    const [codPosicionEdit, setCodPosicionEdit] = useState('');
    const [optionsLoaded, setOptionsLoaded] = useState(false);

    let detalle = {}

    detalle = props.dataEdit

    //DIALOG METODOS MSJ ********************
    //Open Close
    const [openMsj, setOpenMsj] = useState(false)
    //Msj Error
    const [msjTitle, setMsjTitle] = useState("")

    const MsjElement = ({ severityProp }) => {
        return (
            <Collapse in={openMsj}>
                <Alert severity={severityProp} onClose={() => { setOpenMsj(false) }}>
                    {msjTitle}
                </Alert>
            </Collapse>
        );
    };

    //DIALOG METODOS MSJ ********************


    useEffect(() => {


        //setLoading(true);
        getLeyendaPosicionList(accessToken)
            .then((data) => {
                setPosiciones(data);
                setOptionsLoaded(true);
                if (detalle.DescPosicion) {
                    const posicionEdit = data.find(p => p.Descripcion === detalle.DescPosicion)
                    setCodPosicionEdit(posicionEdit.CodLeyendaPosicion);
                }
            })
            .catch()
            .finally(/*() => setLoading(false)*/);


        getFormulariosList(accessToken)
            .then((data) => {

                setFormulariosLst(data);
                //setLoading(false);
            })
            .catch()
            .finally(/*() => setLoading(false)*/);

        if (props.dataEdit != undefined && props.dataEdit.CodLeyenda != 0) {
            setValCodLeyendaPosicion(props.dataEdit.CodLeyendaPosicion);
            setValCodFormulario(props.dataEdit.CodFormulario);
            setValDescLey(props.dataEdit.DescLey);
            setValValorUno(props.dataEdit.ValorUno);
            setValValorDos(props.dataEdit.ValorDos);
            setValValorTres(props.dataEdit.ValorTres);
        }


    }, [accessToken]);

    const codLeyendaPosicionChange = (event) => {
        setValCodLeyendaPosicion(event.target.value);
    };

    const CodFormularioChange = (event) => {
        setValCodFormulario(event.target.value);
    };

    const DescLeyChange = (value) => {
        setValDescLey(value);
    };

    const ValorUnoChange = (value) => {
        setValValorUno(value);
    };
    const ValorDosChange = (value) => {
        setValValorDos(value);
    };
    const ValorTresChange = (value) => {
        setValValorTres(value);
    };

    const onAceptar = (e) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);



        if (props.dataEdit != undefined && props.dataEdit.CodLeyenda != undefined && props.dataEdit.CodLeyenda != 0) {
            //Edit

            const frmImgUpdateLeyendaSocRequest = Object.fromEntries(formData);
            const datos = { frmImgUpdateLeyendaSocRequest }
            datos.frmImgUpdateLeyendaSocRequest.CodLeyenda = props.dataEdit.CodLeyenda;
            datos.frmImgUpdateLeyendaSocRequest.Descripcion = valDescLey;
            datos.frmImgUpdateLeyendaSocRequest.ValorUno = valValorUno;
            FrmUpdateLeyendaSoc(datos, accessToken)
                .then(data => {
                    if (data != undefined && data.Message != undefined && data.Message.includes("Error")) {
                        setMsjTitle(data.Message);
                        setOpenMsj(true);
                        return;
                    } else {
                        //const dataNew = { ...datos.frmUpdateLeyendasFirmasSocRequest, DescLeyenda: selectedLeyenda, DescImagen: selectedFirma, DescPosicion: selectedPosicion, CodLeyendaFirma: props.dataEdit.CodLeyendaFirma };
                        //props.setData(dataNew);
                        props.pInit();
                        props.handleClose();
                    }
                }).catch(
                    error => {
                        setMsjTitle(error.toString());
                        setOpenMsj(true);
                    });

        } else {
            //New
            const frmImgInsertLeyendaSocRequest = Object.fromEntries(formData);
            const selectedOptionLabel = posiciones.find((option) => option.CodLeyendaPosicion === formData.get("CodLeyendaPosicion"))?.Descripcion;
            const datos = { frmImgInsertLeyendaSocRequest }

            addLeyenda(datos, accessToken)
                .then(data => {
                    if (data.Message != undefined && data.Message.includes("Error")) {
                        setMsjTitle(data.Message);
                        setOpenMsj(true);
                        return;
                    } else {
                        props.pInit();
                        props.handleClose();
                    }
                }).catch(
                    error => {
                        setMsjTitle(error.toString());
                        setOpenMsj(true);
                    });
        }
    }

    return (
        <Box component={'form'} onSubmit={onAceptar}>
            <Capa onCancel={props.handleClose} title={"Leyenda"}>
                <Box sx={{ display: 'flex', flexDirection: 'column', pb: 2 }}>
                    <TextField id="outlined-basic" label="Descripción" variant="outlined" name="Descripcion" autoComplete="off" value={valDescLey} required
                        onChange={(e) => DescLeyChange(e.target.value)}
                    />

                    <FormControl fullWidth required>
                        <InputLabel id="posicion-select-label">Formulario</InputLabel>

                        <Select
                            labelId="formulario-select-label"
                            id="formulario-select"
                            value={valCodFormulario}
                            label="Formulario"
                            onChange={CodFormularioChange}
                            sx={{ m: 1 }}
                            name="CodFormulario"
                        >
                            {formulariosLst.map((option) => (
                                <MenuItem key={option.Descripcion} value={option.CodFormulario}>
                                    {option.Descripcion}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    <TextField sx={{ p: 1 }} id="outlined-basic" label="Valor 1 " variant="outlined" name="ValorUno" autoComplete="off" onChange={(e) => ValorUnoChange(e.target.value)} value={valValorUno} required />
                    <TextField sx={{ p: 1 }} id="outlined-basic" label="Valor 2" variant="outlined" name="ValorDos" autoComplete="off" onChange={(e) => ValorDosChange(e.target.value)} value={valValorDos} />
                    <TextField sx={{ p: 1 }} id="outlined-basic" label="Valor 3" variant="outlined" name="ValorTres" autoComplete="off" onChange={(e) => ValorTresChange(e.target.value)} value={valValorTres} />
                    {/*<TextField sx={{ p: 1 }} id="outlined-basic" label="Posición" variant="outlined" required />*/}
                    <FormControl fullWidth required>
                        <InputLabel id="posicion-select-label">Posición</InputLabel>

                        <Select
                            labelId="posicion-select-label"
                            id="posicion-select"
                            value={valCodLeyendaPosicion}
                            label="Posición"
                            onChange={codLeyendaPosicionChange}
                            sx={{ m: 1 }}
                            name="CodLeyendaPosicion"
                        >
                            {posiciones.map((option) => (
                                <MenuItem key={option.Descripcion} value={option.CodLeyendaPosicion}>
                                    {option.Descripcion}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <MsjElement severityProp="error"></MsjElement>
            </Capa>
        </Box>
    );
}

export default LeyendaView;